var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"fill-height",attrs:{"justify":"center","align":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }